export default "__VITE_ASSET__BvFb50lj__"